module.exports = __webpack_public_path__ + "static/antd-table-dnd-rows-11c83e8650c989cfe79f3c133be12d55.gif";